import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { LoginIdService } from "./login-id.service";
import { User } from "../model/user";
import { UserGroupDto } from "../model/userGroupDto";
import { UserGroupInvite } from "../model/userGroupInvite";
import { UserGroupManagementDto } from "../model/userGroupManagementDto";
import { UserCompanyGroup } from "../model/userCompanyGroup";
import { UserCompanyGroupDto } from "../model/userCompanyGroupDto";
import { CompanyLogin } from "../model/companyLogin";

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  options = {};
  constructor(private httpClient: HttpClient, private loginIdService: LoginIdService) {
    this.loginIdService.headersChanged$.subscribe(headers => {
      this.options = headers;
    });
  }

  // The UserGroupDto has to be converted into a UserGroup by passing the DTO to the UserGroup constructor
  getUserGroupsFromCompany(loginId): Observable<UserGroupDto[]> {
    return this.httpClient.get<UserGroupDto[]>("/api/company-login/" + loginId + "/user-groups", this.options);
  }

  // Cant use actual UserGroup here, but a UserGroupDto with a plain object for the permissions map
  // The UserGroupDto has to be converted into a UserGroup by passing the DTO to the UserGroup constructor
  updateUserGroup(userGroup: UserGroupDto): Observable<UserGroupDto> {
    return this.httpClient.put<UserGroupDto>("/api/company-login/"+ userGroup.companyLoginId +"/user-group/" + userGroup.id, userGroup, this.options);
  }

  // Cant use actual UserGroup here, but a UserGroupDto with a plain object for the permissions map
  // The UserGroupDto has to be converted into a UserGroup by passing the DTO to the UserGroup constructor
  createUserGroup(userGroup: UserGroupDto): Observable<UserGroupDto> {
    return this.httpClient.post<UserGroupDto>('/api/company-login/' + userGroup.companyLoginId + '/user-group', userGroup, this.options);
  }

  deleteUserGroup(loginId: string, userGroupId: number): Observable<boolean> {
    return this.httpClient.delete<boolean>('/api/company-login/' + loginId + '/user-group/' + userGroupId, this.options);
  }

  getUserGroupInvites(userGroupId: number): Observable<UserGroupInvite[]> {
    return this.httpClient.get<UserGroupInvite[]>('/api/user-group/' + userGroupId + '/invites', this.options);
  }

  getAllOpenUserGroupInvitesFromCompanyLogin(loginId: String) {
    return this.httpClient.get<UserGroupInvite[]>('/api/company-login/' + loginId + '/invites');
  }

  verifyToken(token: string): Observable<UserGroupInvite> {
    return this.httpClient.get<UserGroupInvite>('/api/invites/verify/' + token, this.options);
  }

  createInvitesAndAssignPermissions(data: {loginId: string; groupId: number; userMails: String[]}): Observable<UserGroupInvite[]> {
    return this.httpClient.post<UserGroupInvite[]>('/api/user-group/' + data.groupId + '/invites', data, this.options);
  }

  getUserGroupManagement(loginId: string): Observable<UserGroupManagementDto[]>  {
    return this.httpClient.get<UserGroupManagementDto[]>('/api/company-login/' + loginId + '/user-group-management', this.options);
  }

  getOrphanedUsersFromCompanyLogin(loginId: string): Observable<User[]> {
    return this.httpClient.get<User[]>('/api/company-login/' + loginId + '/orphans', this.options);
  }

  getCompanyLoginsFromUserPrincipal(): Observable<CompanyLogin[]> {
    return this.httpClient.get<CompanyLogin[]>('/api/company-logins/principal', this.options);
  }

  getUserCompanyGroupsFromPrincipal(withProfileId: boolean, options: {} = {}): Observable<UserCompanyGroupDto[]> {
    const requestParam : string = withProfileId ? '?withProfileId=true' : '';
    return this.httpClient.get<UserCompanyGroupDto[]>("/api/user-company-group" + requestParam, options);
  }

  getUserCompanyGroupFromUserInCompany(userId: string, companyLoginId: string) {
    const ucg = new UserCompanyGroup(null);
    ucg.companyLoginId = companyLoginId;
    ucg.userid = userId;
    return this.httpClient.post<UserCompanyGroup>('/api/user-company-group/user/' + ucg.userid, ucg, this.options);
  }

  moveUserToAnotherUserGroup(update : UserCompanyGroup) {
    return this.httpClient.put<UserCompanyGroup>('/api/user-company-group/' + update.id, update, this.options);
  }

  renewInvite(invite: UserGroupInvite) {
    return this.httpClient.put<UserGroupInvite>('/api/user-group/' + invite.userGroupId + '/invites/' + invite.id, invite, this.options)
  }

  deleteInvite(userGroupId: number, inviteId: number) {
    return this.httpClient.delete('/api/user-group/' + userGroupId + '/invites/' + inviteId);
  }
}
